/**
 * Living Outdoorsy - Variant Image Switch Fix
 *
 * Problem: The theme updates the main gallery image's `src` attribute on variant
 * change, but not the `srcset`. Browsers prioritize `srcset` over `src`, so the
 * image appears static even though the src value changed.
 *
 * Fix: Uses a MutationObserver to watch for `src` changes on the main gallery
 * image and automatically rebuilds the `srcset` to match. Also syncs the active
 * thumbnail highlight.
 *
 * Installation:
 * 1. In Shopify admin, go to Online Store > Themes > Edit Code
 * 2. Under "Assets", click "Add a new asset" > Create blank file > name it
 *    "lo-variant-image-fix.js"
 * 3. Paste this entire file's contents and Save
 * 4. Open "Snippets" or "Sections" and find your product template
 *    (likely sections/product.liquid, sections/main-product.liquid,
 *    or similar)
 * 5. Just before the closing </section> or at the bottom, add:
 *    <script src="{{ 'lo-variant-image-fix.js' | asset_url }}" defer></script>
 * 6. Save and test
 */

(function() {
  'use strict';

  function initVariantImageFix() {
    var mainImg = document.querySelector('.lo-product-gallery-main img');
    if (!mainImg) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'src') {
          var newSrc = mainImg.getAttribute('src');
          if (!newSrc) return;

          /* Rebuild srcset with Shopify CDN responsive widths */
          var baseSrc = newSrc.split('?')[0];
          var params = newSrc.indexOf('?') > -1 ? '?' + newSrc.split('?')[1] : '';
          var widths = [180, 360, 540, 720, 900, 1080];
          var newSrcset = widths.map(function(w) {
            var resized = baseSrc.replace(/\.([a-z]+)$/i, '_' + w + 'x.$1') + params;
            return resized + ' ' + w + 'w';
          }).join(', ');

          mainImg.setAttribute('srcset', newSrcset);

          /* Sync active thumbnail highlight */
          var thumbs = document.querySelectorAll('.lo-product-thumb');
          var newFilename = newSrc.split('/').pop().split('?')[0];
          thumbs.forEach(function(thumb) {
            var thumbImg = thumb.querySelector('img');
            if (thumbImg) {
              var thumbFile = thumbImg.src.split('/').pop().split('?')[0];
              if (thumbFile === newFilename) {
                thumb.classList.add('active');
              } else {
                thumb.classList.remove('active');
              }
            }
          });
        }
      });
    });

    observer.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantImageFix);
  } else {
    initVariantImageFix();
  }
})();
